<template>
	<div class="MAM_queryList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="queryForm.client_num" placeholder="提现流水号"></el-input>
				</el-form-item>
			

				<el-form-item>
					<el-date-picker type="date" placeholder="提现开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
					-
					<el-date-picker type="date" placeholder="提现结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
				</el-form-item>
	<el-form-item>
					<el-input size clearable v-model="queryForm.real_name" placeholder="提现发起人"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>

				<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
					:loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card class="box-card header" shadow="hover" style="margin-top:20px">
			<div class="headerDivd">
				<div class="headerMoney">{{stockTable.last_total_money}}</div>
				<div style="margin:5px 0px;">昨日利润 (元)</div>
			</div>
			<div class="headerDivd">
				<div class="headerMoney">{{stockTable.last_nums}}</div>
				<div style="margin:5px 0px;">昨日总提现笔数</div>
			</div>
			<div class="headerDivd">
				<div class="headerMoney">{{stockTable.total_money_all}}</div>
				<div style="margin:5px 0px;">总利润额 (元)</div>
			</div>
			
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">

			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">

				<el-table-column header-align="center" align="center" prop="client_num" label="提现流水号"></el-table-column>
				<el-table-column header-align="center" align="center" prop="repay_time" label="提现时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="real_name" label="提现发起人"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="代理商编号"></el-table-column>
				<el-table-column header-align="center" align="center" prop="money" label="提现金额"></el-table-column>
				<el-table-column header-align="center" align="center" prop="fee_money" label="提现手续费"></el-table-column>
				<el-table-column header-align="center" align="center" prop="service_fee" label="提现服务费"></el-table-column>
				<el-table-column header-align="center" align="center" prop="total_money" label="利润额"></el-table-column>
				
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>

	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "activityWithdrawalPoint",
		data() {
			return {
				queryForm: {
					user_id: this.$route.query.user_id,
					is_list: 2,
					type:9,
					start_time:'',
					end_time:'',
					client_num:'',
					real_name:'',
				},
				stockTable: { //列表
					list: [],
					last_total_money: 0,
					last_nums: 0,
					total_money_all: 0,
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0, //总数
				},
				loading: true,
				downLoading: false, //导出loading
			}
		},
		mounted() {
			this.handleDefaultTime()
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				user_id: this.$route.query.user_id,
				is_list: 2,
				type:9,
				start_time:this.queryForm.start_time,
				end_time:this.queryForm.end_time
			})
		},
		components: {
			paginations,
		},
		methods: {
			handleDownLoad(params) { //导出
				let reqData = {
					type: 13,
					value: JSON.stringify(params)
				};
			
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			handleDefaultTime() { //默认获取三十天
			    let date =this.$moment().endOf('day').format('x');
			    this.queryForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD");
			    this.queryForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD");
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				queryForm.is_list = 2;
				queryForm.type = 9;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("userteamleader/getUserTeamWithDrawLogList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.page.total = data.list.total; //总数
						this.stockTable.list = res.data.list.data;

						this.stockTable.last_total_money = res.data.last_total_money;
						this.stockTable.last_nums = res.data.last_nums;
						this.stockTable.total_money_all = res.data.total_money_all;
					} else {
						this.$message.error(res.msg);
					}
					// //渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.header>.el-card__body {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.headerDivd {
		padding-right: 50px;
		font-size: 14px;
		color: #E6A23C;
	}

	.headerMoney {
		font-size: 28px;
		font-weight: bold;
	}
</style>